var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "pause_circle"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6717_6870",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 42,
    height: 42
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 42,
    height: 42,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6717_6870)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pause_circle_2",
    d: "M15.7517 28.0017H19.2517V14.0017H15.7517V28.0017ZM22.7517 28.0017H26.2517V14.0017H22.7517V28.0017ZM21.0017 38.5017C18.5809 38.5017 16.3059 38.0423 14.1767 37.1236C12.0475 36.2048 10.1955 34.958 8.62046 33.383C7.04546 31.808 5.79858 29.9559 4.87983 27.8267C3.96108 25.6975 3.50171 23.4225 3.50171 21.0017C3.50171 18.5809 3.96108 16.3059 4.87983 14.1767C5.79858 12.0475 7.04546 10.1955 8.62046 8.62046C10.1955 7.04546 12.0475 5.79858 14.1767 4.87983C16.3059 3.96108 18.5809 3.50171 21.0017 3.50171C23.4225 3.50171 25.6975 3.96108 27.8267 4.87983C29.9559 5.79858 31.808 7.04546 33.383 8.62046C34.958 10.1955 36.2048 12.0475 37.1236 14.1767C38.0423 16.3059 38.5017 18.5809 38.5017 21.0017C38.5017 23.4225 38.0423 25.6975 37.1236 27.8267C36.2048 29.9559 34.958 31.808 33.383 33.383C31.808 34.958 29.9559 36.2048 27.8267 37.1236C25.6975 38.0423 23.4225 38.5017 21.0017 38.5017Z",
    fill: "#5F6CE1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.28dfa68f75698a0e869004c93fb7ccb4.svg";
export { ForwardRef as ReactComponent };